import {
  AgentEventPayload,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createAgentEventMessageHandler(eventEmitter: IEventEmitter) {
  return (action: WebSocketAction, item: AgentEventPayload) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug('[AgentEventHandler] INSERT AgentEvent');
          eventEmitter.emit(
            WebSocketEntityType.AgentEvent,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug('[AgentEventHandler] MODIFY AgentEvent');
          eventEmitter.emit(
            WebSocketEntityType.AgentEvent,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        default:
          log.warn(
            '[AgentEventHandler] Unknown action for AgentEvent:',
            action,
          );
      }
    } catch (error) {
      log.error('[AgentEventHandler] Handler failed:', error);
    }
  };
}
